var exports = {
  "G1": "xcc377c0b--ae2a68--expanded-container",
  "kL": "xcc377c0b--ae2a68--container",
  "nf": "xcc377c0b--ae2a68--link",
};

module.exports = exports;
